// Direct matchMedia check instead of useMedia() which doesn't compile
// correctly through Tamagui and causes hydration flashes.
// Device hover capability doesn't change mid-session so a module-level
// constant is sufficient.
export const canHover =
  typeof window !== 'undefined'
    ? !window.matchMedia('(hover: none)').matches
    : true // assume hover on SSR (desktop default)
